// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getPoolOrderExchangesResults, getTransDateCodes } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PoolOrderExchangesTable from './components/pool-order-exchanges-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PoolOrderExchanges extends Component {

    state = {

        transDate: [],
        selectedTransDate: '',
        order: '',
        totalCount: 0,
        results: null
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getTransDateCodes( ).then( response => {

            const selectedTD = response.transDate.length ? response.transDate[0] : '';

            this.setState( {
                transDate: response.transDate,
                selectedTransDate: selectedTD
            } );
            this.props.decreaseCounter();

            this.refresh();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value

        } );

    }

    handleTransDateChange ( val ) {

        this.setState( {
            selectedTransDate: val

        } );

    }

    onClear () {

        this.setState( {
            selectedTransDate: '',
            order: '',
            totalCount: 0,
            results: null
        } );

    }

    refresh () {

        const transDate = this.state.selectedTransDate !== '-1' ? formatGivenDate( Number( this.state.selectedTransDate ), 'YYYY-MM-DD' ) : '';
        this.props.increaseCounter();
        getPoolOrderExchangesResults( transDate, this.state.order )
            .then( response => {

                this.setState( {
                    results: response.poolOrderExchangeResults,
                    totalCount: response.transCount
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            transDate, selectedTransDate, order, totalCount, results
        } = this.state;

        const transDates = transDate ? transDate.map( date => ( {
            label: formatGivenDate( Number( date ), 'YYYY-MM-DD' ), id: Number( date )
        } ) ) : [];

        const fullRes = results && results.map( i => (
            { ...i, unitName: this.props.unit.name } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Pool Order Exchanges</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-pool-order-exchange-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="date"
                                    label="Trans Date"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTransDateChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={transDates}
                                    placeholder=" "
                                    selectedValue={selectedTransDate}
                                />
                                <LabeledInput
                                    className="order"
                                    name="Order"
                                    isEditable={true}
                                    label="Order"
                                    maxLength={12}
                                    onChange={this.handleTextChange.bind( this, 'order' )}
                                    value={order}
                                    isRequired={false}
                                />
                                <button className="primary-button" type="button" onClick={this.refresh.bind( this )}>
                                    <span> Filter </span>
                                </button>
                                <button type="button" onClick={this.onClear.bind( this )}>
                                    <span> Clear </span>
                                </button>
                            </div>

                        </div>
                        {results !== null && (
                            <section className="messagecontainer">
                                <div className="displayMessage">Total Rows: {totalCount}</div>
                            </section>
                        )}
                        {results !== null && (
                            <PoolOrderExchangesTable
                                results={fullRes}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PoolOrderExchanges.displayName = 'PoolOrderExchanges';
PoolOrderExchanges.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PoolOrderExchanges ) );
